<script lang="ts">
	interface Props {
		autoplay: boolean
		paused?: boolean
		portrait?: boolean
		relative?: boolean
		play: () => void
		pause: () => void
		full: () => void
	}

	let { autoplay, paused = $bindable(), portrait, relative, play, pause, full }: Props = $props()
</script>

<div class="controls" class:autoplay class:relative>
	{#if paused}
		<button class="play" class:portrait class:autoplay aria-label="Play" onclick={play}>
			<svg class="svg" height="30" width="30">
				<use xlink:href="/images/vector.svg#{autoplay ? 'small-play' : 'large-play'}"></use>
			</svg>
		</button>
	{:else}
		<button class="pause" class:portrait class:autoplay aria-label="Pause" onclick={pause}>
			<svg class="svg" height="30" width="30">
				<use xlink:href="/images/vector.svg#{autoplay ? 'small-pause' : 'pause'}"></use>
			</svg>
		</button>
	{/if}
	{#if autoplay}
		<button class="action" aria-label="Play" onclick={full}>Watch Full Video</button>
	{/if}
</div>

<style lang="css">
	.controls {
		display: contents;

		&.autoplay {
			display: flex;
			font: 500 var(--f-signpost);
			letter-spacing: var(--ls-signpost);
			gap: 1rem;
			inset: auto auto 1rem 1rem;
			position: absolute;

			@media (--from-mobile) {
				inset: auto auto 1.25rem 1.5rem;
			}
		}

		&.relative {
			inset: unset;
			position: relative;
		}
	}

	.play,
	.pause {
		color: var(--c-white);
		border-radius: 50%;
		inset: 50% auto auto 50%;
		position: absolute;
		size: 5rem;
		translate: -50% -50%;

		@starting-style {
			size: 1.875rem 1.5625rem;
		}

		.svg {
			size: 5rem;

			@starting-style {
				size: 1.875rem 1.5625rem;
			}
		}

		&.autoplay {
			box-shadow: unset;
			color: var(--c-gimson);
			border-radius: unset;
			inset: unset;
			position: relative;
			size: 1.875rem 1.5625rem;
			translate: unset;

			.svg {
				size: 1.875rem 1.5625rem;
			}
		}

		&.portrait {
			size: 4rem;

			.svg {
				size: 4rem;
			}
		}
	}

	.pause {
		opacity: 0;

		&.autoplay,
		&:hover {
			opacity: 1;
		}
	}

	.action {
		color: var(--c-gimson);
		font: 500 var(--f-signpost);
		letter-spacing: var(--ls-signpost);
		text-transform: uppercase;
	}
</style>
